/**
 * Duels between two real players (docs/handoff/newdir/S3.md): the numbers. The rules are `systems/pvpDuel.ts`, the
 * server's challenge flow is `apps/server/src/duels.ts`. A bout is fought in a private World of its own (the ring),
 * to a tenth of the health (`DUEL_GROUND.floorHp`), nothing staked; both go back whole to where they stood.
 */
export const PVP_DUEL = {
  /** Seconds a challenge waits for an answer before it lapses. */
  inviteSeconds: 20,
  /** The countdown before blows count, and how long the result stays up before both are sent back. */
  countdown: 3,
  result: 4,
  /** A bout nobody finishes is decided on the share of health left. */
  maxSeconds: 180,
  /** How near (metres) the challenged must be to the challenger. */
  reach: 12,
} as const;
